import * as React from "react";
import Image from "./Image";
import VisibilityObserver from "./VisibilityObserver";
import { isVisible } from "./Visibility";
const LazyImage = (props) => {
    const lazyDefault = { ...props.default, width: 50 };
    const lazyQueries = props.queries.map((query) => ({
        ...query,
        size: { ...query.size, width: 50 },
    }));
    return (React.createElement(VisibilityObserver, null, (visibility) => {
        switch (visibility) {
            case "Initial":
                return React.createElement(React.Fragment, null, "\u00A0");
            case "NotVisible":
            case "Visible":
                return (React.createElement(Image, { crop: props.crop, default: isVisible(visibility) ? props.default : lazyDefault, queries: isVisible(visibility) ? props.queries : lazyQueries, blur: isVisible(visibility)
                        ? props.blur ?? 0
                        : props.lazyBlur ?? 150, className: props.className, style: props.style, alt: props.alt, onLoad: props.onLoad, forceCrop: props.forceCrop, environment: props.environment }));
        }
    }));
};
export default LazyImage;
//# sourceMappingURL=LazyImage.js.map